export default __webpack_public_path__ + "1c4c52d2fb320f28b3286dbe0141a84c.webp";